import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading esports content..." @subtitle="Gathering tournament updates and competitive gaming news" />
</template>
);
